import React from "react";
import * as api from '../../api';
import H2 from "../Atoms/H2";
import { useTranslation } from 'react-i18next';
import H1 from "../Atoms/H1";
import { Link, useNavigate } from "react-router-dom";
import Section from "../Atoms/Section";
import Spinner from "../../Plateforme/Atoms/Spinner";
import UppercaseInfo from "../Atoms/UppercaseInfo";
import BoldBlue from "../Atoms/BoldBlue";
import { typologiesEspace, typologiesObjet } from "../Utils/Listings";
import MiniatureContainer from "../Atoms/MiniatureContainer";
import Miniature from "../Atoms/Miniature";
import GetProjectMainImage from "../Utils/GetProjectMainImage";
import PressLinksDisplay from "../Atoms/PressLinksDisplay";
import AwardsDisplay from "../Atoms/AwardsDisplay";
import Text10LinesMax from "../Atoms/Text10LinesMax";
import { userHasFullAccess } from "../Utils/Validator";
import H0 from "../Atoms/H0";
import Slider from "../Components/Slider";

const Project = (props) => {

    const [project, setProject] = React.useState({});
    const [company, setCompany] = React.useState({});
    const [loading, setLoading] = React.useState(true);
    const { i18n } = useTranslation('common');
    const navigate = useNavigate();
    const urlParams = new URLSearchParams(window.location.search);
    const pid = urlParams.get('pid');
    const cid = urlParams.get('cid');
    const public_view = urlParams.get('public_view') === "1";

    React.useEffect(() => {
        if(loading) return;
        if(props.fullUserLoading) return;
        if(!company.company) return;
        if(props.fullUser?.user?._id !== company?.company?.ownerUserId && !userHasFullAccess(props.fullUser, props.fullUserLoading) && !public_view){
            navigate('/');
        }
    }, [props.fullUser, props.fullUserLoading, company, loading]);

    React.useEffect(() => {
        if(!pid || !cid) {navigate('/annuaire'); return};
        setLoading(true);
        api.GetAllCompanyData({id : cid}).then((response) => {
            // console.log(response.data);
            const currentProject = response.data?.company?.projects && response.data?.company.projects?.find((project) => project._id === pid);
            setProject(currentProject);
            setCompany(response.data);
            setLoading(false);
        }).catch((error) => {
            console.log(error);
        });
    }, [pid,cid,navigate]);

    if(loading){
        return (
            <>
                <br/><br/><br/>
                <Spinner/>
            </>
        )
    }

    // Handle case when project is not found
    if(!project){
        return (
            <div style={{textAlign: 'center', padding: '60px 20px'}}>
                <h2>Projet non trouvé</h2>
                <p>Ce projet n'existe pas ou n'est plus disponible.</p>
                <button onClick={() => navigate('/annuaire')} style={{marginTop: '20px', padding: '10px 20px', cursor: 'pointer'}}>
                    Retour à l'annuaire
                </button>
            </div>
        )
    }

    const typologie = typologiesObjet.find((_typologie) => _typologie.code === project.typologie) || typologiesEspace.find((_typologie) => _typologie.code === project.typologie);

    const otherProjectsToShow = company.company.projects.filter((project) => project.public && project._id !== pid);

    return (
        <div>
            <Section className="padding">
                <H0>{project.name?.toUpperCase()}</H0>
            </Section>
            <Section className="padding">
                <UppercaseInfo>{i18n.language === "fr" ? "Société :" : "Company:"}</UppercaseInfo> <UppercaseInfo style={{cursor:"pointer"}} onClick={() => navigate('/company?id=' + company.company?._id + (public_view ? "&public_view=1" : ""))} className="blue"><img src='/img/fleche_bleue.png' alt=''/>{company.hsCompany?.properties?.name}</UppercaseInfo><br/>
                {project.year && <><UppercaseInfo>{i18n.language === "fr" ? "Année de livraison :" : "Delivery year:"}</UppercaseInfo> <UppercaseInfo className="blue">{project.year}</UppercaseInfo><br/></>}
                {typologie && <><UppercaseInfo>{i18n.language === "fr" ? "Typologie :" : "Typology:"}</UppercaseInfo> <UppercaseInfo className="blue">{i18n.language === "fr" ? typologie.fr : typologie.en}</UppercaseInfo><br/></>}
                <UppercaseInfo>{i18n.language === "fr" ? "Type :" : "Type:"}</UppercaseInfo> <UppercaseInfo className="blue">{project.type === "objet" ? (i18n.language === "fr" ? "Objet" : "Object") : (i18n.language === "fr" ? "Espace" : "Space")}</UppercaseInfo><br/>
                {/* <br/>
                <BlueOnBlueLabel>{project.type === "objet" && (i18n.language === "fr" ? "Objet" : "Object")}{project.type === "espace" && (i18n.language === "fr" ? "Espace" : "Space") }</BlueOnBlueLabel> */}
            </Section>
            <Section className="padding">
                <Slider
                    slides={project.medias}
                />
            </Section>
            <Section className="padding">
                <H2>{i18n.language === "fr" ? "À PROPOS" : "ABOUT"}</H2>
            </Section>
            <Section className="flexblock">
                <div>
                    <Text10LinesMax>{i18n.language === "fr" ? project?.aboutfr : project?.abouten}</Text10LinesMax>
                </div>
                <div style={{borderLeft:"1px solid black",paddingLeft:"20px"}} >
                    {project.type === "objet" && <>
                        {project?.fabricant && <>
                            <BoldBlue>{i18n.language === "fr" ? "Fabricant" : "Manufacturer"}</BoldBlue><br/>
                            <span>{project?.fabricant}</span><br/><br/>
                        </>}
                        {project?.fabrication_fr === "oui" && <>
                            <BoldBlue>{i18n.language === "fr" ? "Fabrication Française" : "French manufacturing"}</BoldBlue><br/>
                            <span>{i18n.language === "fr" ? "Oui" : "Yes"}</span><br/><br/>
                        </>}
                        {project?.galerie && <>
                            <BoldBlue>{i18n.language === "fr" ? "Galerie" : "Gallery"}</BoldBlue><br/>
                            <span>{project?.galerie}</span><br/><br/>
                        </>}
                        {project.showclient && project.client && <>
                            <BoldBlue>{i18n.language === "fr" ? "Client/Commanditaire" : "Client"}</BoldBlue><br/>
                            <span>{project.client}</span><br/><br/>
                        </>}
                        {project?.libre_edition === "oui" && <>
                            <BoldBlue>{i18n.language === "fr" ? "Édition" : "Edtion"}</BoldBlue><br/>
                            {i18n.language === "fr" ? "Libre à l'édition" : "Free to edit"}<br/><br/>
                        </>}
                        {project?.libre_edition === "non" && project?.editeur && <>
                            <BoldBlue>{i18n.language === "fr" ? "Editeur" : "Editor"}</BoldBlue><br/>
                            {project?.editeur}<br/><br/>
                        </>}
                    </>}
                    {project.type === "espace" && <>
                        {project?.adresse && <>
                            <BoldBlue>{i18n.language === "fr" ? "Adresse du projet" : "Project address"}</BoldBlue><br/>
                            <span>{project?.adresse}</span><br/><br/>
                        </>}
                        {project?.fabrication_fr === "oui" && <>
                            <BoldBlue>{i18n.language === "fr" ? "Fabrication Française" : "French manufacturing"}</BoldBlue><br/>
                            <span>{i18n.language === "fr" ? "Oui" : "Yes"}</span><br/><br/>
                        </>}
                        {project.showclient && project.client && <>
                            <BoldBlue>{i18n.language === "fr" ? "Client/Commanditaire" : "Client"}</BoldBlue><br/>
                            <span>{project.client}</span><br/><br/>
                        </>}
                    </>}
                    <PressLinksDisplay
                        pressLinks={project.lien_presse}
                    />
                    <AwardsDisplay
                        awards={project.awards}
                    />
                </div>
            </Section>
            {otherProjectsToShow.length > 0 && <Section className="padding">
                <H1>{i18n.language === "fr" ? "Autres projets de" : "Other projects by"} {company.hsCompany?.properties?.name}</H1>
            </Section>}
            {otherProjectsToShow.length > 0 && <Section className="padding">
                <br/>
                <MiniatureContainer>
                    {otherProjectsToShow.map((project) => {
                        if(project.type === "objet") return (
                            <Link to={"/project?pid=" + project._id + "&cid=" + company.company?._id + (public_view ? "&public_view=1" : "")} key={project._id}>
                                <Miniature
                                    imagePath={GetProjectMainImage(project)}
                                    title={project.name}
                                    tag={i18n.language === "fr" ? "Projet" : "Project"}
                                    //no privacy
                                    keyInfo={project.adresse}
                                    category={project.libre_edition === "oui" ? (i18n.language === "fr" ? "Libre à l'édition" : "Free to edit") : project.editeur}
                                />
                            </Link>
                        ); return (
                            <Link to={"/project?pid=" + project._id + "&cid=" + company.company?._id + (public_view ? "&public_view=1" : "")} key={project._id}>
                                <Miniature
                                    imagePath={GetProjectMainImage(project)}
                                    title={project.name}
                                    tag={i18n.language === "fr" ? "Projet" : "Project"}
                                    //no privacy
                                    keyInfo={project.adresse}
                                    category={project.fabrication_fr === "oui" ? (i18n.language === "fr" ? "Fabrication française" : "French manufacturing") : null}
                                />
                            </Link>
                        );
                    })}
                </MiniatureContainer>
                <br/>
            </Section>}
        </div>
    );
};

export default Project;

